import { render, staticRenderFns } from "./OmissionLoader.vue?vue&type=template&id=8d15ce7e"
import script from "./OmissionLoader.vue?vue&type=script&lang=ts"
export * from "./OmissionLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports